import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';

import axios from 'axios';
import TitleBlock from './TitleBlock';
import ContentBlock from './ContentBlock';
import strip from '../images/strips.svg';

export default class extends PureComponent {
    state = {
        title: null,
        blockTitle: null,
        textContent: null,
        image: null
    }

    componentWillMount() {
        this.props.setWhiteLogo(true);
    }

    componentDidMount() {
        this.getPageContent();
    }

    async getPageContent() {
        const response = await axios.get(process.env.CMS_URL + '/wp-json/wp/v2/pages/105?acf_format=standard');
        
        const fields = response.data.acf;

        this.setState({
            title: response.data.title.rendered,
            blockTitle: fields.title,
            textContent: fields.text_content,
            image: fields.image.sizes.large,
            metaTitle: fields.page_title,
            metaDesc: fields.meta_description
        }, () => {
            this.animatePage();
        });
    }

    animatePage() {
        const about = document.getElementById('About');
        setTimeout(() => {
            about.classList.add('__active');
        }, 100);
    }

    isQuizComplete() {
        const localStorageState = localStorage.getItem('state');

        if (!localStorageState) {
            return false;
        }

        const localState = JSON.parse(localStorageState);

        return localState.isQuizComplete;
    }

    render() {
        const { title, textContent, image, blockTitle, metaTitle, metaDesc } = this.state;
        
        return (
            <div className="about" id="About">
                {title && textContent && image && blockTitle && (
                    <span>
                        <MetaTags>
                            <title>{metaTitle}</title>
                            <meta property="og:title" content={metaTitle} />
                            <meta name="description" content={metaDesc} />
                        </MetaTags>
                        <img src={strip} alt="" className="about-strip" />
                        <div className="about-wrap">
                            <div className="row no-gutters">
                                <div className="col-md-6 col-lg-5">
                                    <div className="about-titlewrap">
                                        <TitleBlock title={title}/>
                                    </div>
                                </div>

                                <div className=" d-none d-md-block col-md-4 col-lg-4 col-xl-3">
                                    <img src={image} className="about-image" />
                                </div>

                                <div className="col-xl-4">
                                    <ContentBlock blockTitle={blockTitle} textContent={textContent}/>
                                </div>
                            </div>
                            
                            <div className="about-button">
                                <Link to="/question/1" className="beginbutton">
                                    <div className="beginbutton-inner">
                                        Begin quiz
                                        <span />
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </span>
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/About/index.js